var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Unfalldokumentation",
          },
          on: { change: _vm.reloadBaseFormData, save: _vm.saveBaseFormData },
          scopedSlots: _vm._u(
            [
              _vm.formContext.permissions.canCreateRetroactiveChangesNote ===
              true
                ? {
                    key: "after-icons",
                    fn: function () {
                      return [
                        _c("csp-retroactive-changes-modal", {
                          attrs: {
                            "record-id": _vm.recordId,
                            title: "Unfalldokumentation",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _c("h2", [_vm._v("Grunddaten Unfall")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Datum des Unfalls",
                      property: "accidentDateTime",
                      required: true,
                      type: "datepicker",
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Anlieferungszeit",
                      property: "deliveryTime",
                      required: true,
                      step: "60",
                      type: "time",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "5" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Unfallschilderung",
                      property: "accidentDescription",
                      type: "textarea",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "5" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Straße",
                              property: "accidentStreet",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "PLZ",
                              property: "accidentPostalCode",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Ort",
                              property: "accidentPlace",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "6" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Spedition",
                      "options-loader": _vm.loadDeliveryFirmOptions,
                      property: "deliveryFirmId",
                      type: "autocomplete",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("csp-desktop-info-card-element", {
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Lieferscheinnummer",
                      property: "deliveryReceiptNumber",
                      type: "text",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "mb-5" }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "grid" },
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("h2", [_vm._v("Vorgang")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              disabled: true,
                              "form-context": _vm.formContext,
                              label: "Aktenzeichen AC",
                              property: "referenceNumber",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              disabled: true,
                              "form-context": _vm.formContext,
                              label: "Aktenzeichen SD",
                              property: "referenceNumberDamageServiceProvider",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              disabled: true,
                              "form-context": _vm.formContext,
                              label: "Aktenzeichen RA",
                              property: "referenceNumberLawyer",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Auftragsnummer",
                              property: "orderNumber",
                              type: "text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist gesteuert",
                              property: "isCaseSteered",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCaseSteered") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Steuerungsart",
                                  property: "steeredCaseType",
                                  type: "autocomplete",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist werkstattgebunden",
                              property: "isCommittedToWorkshop",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "wurde polizeilich aufgenommen",
                              property: "isRecordedByPolice",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              inversed: true,
                              label: "Schädiger ist selbst Fahrer",
                              property: "hasAdversaryDifferentDriver",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("h2", [_vm._v("Fahrzeug")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              disabled: _vm.isCarLeasedDisabled,
                              "form-context": _vm.formContext,
                              label: "ist geleast",
                              property: "isCarLeased",
                              type: "optionalBoolean",
                            },
                            on: { change: _vm.handleCarIsLeasedChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarLeased") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Leasinggeber",
                                  "options-loader":
                                    _vm.loadLeasingCompanyOptions,
                                  property: "leasingCompanyId",
                                  type: "autocomplete",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarLeased") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Leasingvertragsnummer",
                                  property: "leasingContractNumber",
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarLeased") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "IBAN des Leasinggebers",
                                  property: "leasingBankAccountIban",
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              disabled: _vm.isCarFinancedDisabled,
                              "form-context": _vm.formContext,
                              label: "ist finanziert",
                              property: "isCarFinanced",
                              type: "optionalBoolean",
                            },
                            on: { change: _vm.handleCarIsFinancedChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarFinanced") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Finanzierende Bank",
                                  "options-loader":
                                    _vm.loadFinancingCompanyOptions,
                                  property: "financingCompanyId",
                                  type: "autocomplete",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarFinanced") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Finanzierungsvertragsnummer",
                                  property: "financingContractNumber",
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarFinanced") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "IBAN der finanzierenden Bank",
                                  property: "financingBankAccountIban",
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "wurde abgeschleppt",
                              property: "wasCarTowed",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "wird repariert",
                              property: "isCarGettingRepaired",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "voraussichtliche Schadenhöhe (in €)",
                              property: "estimatedDamage",
                              type: "autocomplete",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isCarGettingRepaired") ===
                  "no"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Grund für Nichtreparatur",
                                  property: "noRepairReason",
                                  type: "autocomplete",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Fahrzeug hat Vorschäden",
                              property: "vehicleHasPreExistingDamages",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist verkehrssicher",
                              property: "isRoadworthy",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "steht vor Ort",
                              property: "vehicleIsOnSite",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label:
                                "Gravierende Neuteile - Teile die Sie erneuern möchten",
                              property: "partsSeverelyDamaged",
                              type: "textarea",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Auszubeulende Teile mit Arbeitszeit",
                              property: "partsToRemoveOrRepair",
                              type: "textarea",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label:
                                "Ausschließlich Teile die nur lackiert werden",
                              property: "partsToOnlyRepaint",
                              type: "textarea",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  !_vm.formContext.data.hasOwnProperty(
                    "hasDifferingPolicyholder"
                  )
                    ? _c("h2", [
                        _vm._v("\n                Geschädigter\n            "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formContext.data.hasOwnProperty(
                    "hasDifferingPolicyholder"
                  )
                    ? _c("h2", [
                        _vm._v(
                          "\n                Versicherungsnehmer\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist vorsteuerabzugsberechtigt",
                              property: "isCustomerDeductingVatEntitled",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist abweichend vom Halter",
                              property: "hasDifferingPolicyholder",
                              type: "checkbox",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              inversed: true,
                              label: "ist selbst Fahrer",
                              property: "hasCustomerDifferentDriver",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Eigenschaden",
                              property: "isFirstPartyDamage",
                              type: "checkbox",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "wurde verletzt (oder Insassen)",
                              property: "hasInjured",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "nutzt einen Mietwagen",
                              property: "isRentalCarUsed",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formContext.form.getProperty("isRentalCarUsed") === "yes"
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("csp-desktop-info-card-element", {
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Mietwagenherkunft",
                                  property: "carRentalSource",
                                  type: "autocomplete",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist vollkaskoversichert",
                              property:
                                "hasCustomerFullyComprehensiveInsurance",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "ist rechtschutzversichert",
                              property: "isLegalProtectionInsured",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("csp-desktop-info-card-element", {
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Schutzbrief vorhanden",
                              property: "hasBreakdownCover",
                              type: "optionalBoolean",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }